// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"615603cd","583":"c55784f7","736":"a6b1a154","884":"4ce3dc7b"}[chunkId] + ".chunk.js";
};